export default "__VITE_ASSET__C4RK$LOh__"